import { render, staticRenderFns } from "./PifXgsponInfos.vue?vue&type=template&id=25b59a6e&scoped=true"
import script from "./PifXgsponInfos.vue?vue&type=script&lang=js"
export * from "./PifXgsponInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b59a6e",
  null
  
)

export default component.exports